import React from 'react'
import Topbar from '../Components/Topbar'
import Navbar from '../Components/Navbar'
import Pagecontact from './Pagecontact'
import Contacts from './Contacts'
import Footer from '../Home/Footer'
import { CartProvider } from 'react-use-cart'

function AllContact() {
  return (
    <CartProvider>
        <Topbar/>
        <Navbar/>
        <Pagecontact/>
        <Contacts/>
        <Footer/>
    </CartProvider>
  )
}

export default AllContact